import { render, staticRenderFns } from "./VideoCallNotifications.vue?vue&type=template&id=1fa8a110&scoped=true&"
import script from "./VideoCallNotifications.vue?vue&type=script&lang=js&"
export * from "./VideoCallNotifications.vue?vue&type=script&lang=js&"
import style0 from "./VideoCallNotifications.vue?vue&type=style&index=0&id=1fa8a110&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa8a110",
  null
  
)

export default component.exports